import React, { useState } from 'react'
import { FlightTrip, Indigo } from '../../../assests/ExportImageIcon'
import FilterSidebar from '../../../componants/sidebar/filterSidebar'
import FlightDateTabs from '../FlightDateTabs'
import RoundFlightResults from './RoundFlightResults'

const SORT_TABS = [
    { key: 'price', label: 'Price', subtext: 'Low to High' },
    { key: 'fastest', label: 'Fastest', subtext: 'Shortest First' },
    { key: 'departure', label: 'Departure', subtext: 'Earliest First' },
    { key: 'smart', label: 'Smart', subtext: 'Recommendation' },
]

const ONWARD_DATES = [
    { day: 'Wed', date: '24 Jun', price: '₹8,287' },
    { day: 'Thu', date: '25 Jun', price: '₹7,056' },
    { day: 'Fri', date: '26 Jun', price: '₹6,848' },
    { day: 'Wed', date: '24 Jun', price: '₹8,287' },
]

const RETURN_DATES = [
    { day: 'Wed', date: '24 Jun', price: '₹7,268' },
    { day: 'Thu', date: '25 Jun', price: '₹7,139' },
    { day: 'Fri', date: '26 Jun', price: '₹6,948' },
    { day: 'Wed', date: '24 Jun', price: '₹8,287' },    
]

const ONWARD_FLIGHTS = [
    { airline: 'Akasa Air', logo: Indigo, depTime: '07:25', depCode: 'NMI', duration: '2h 10m', stops: 'Non-stop', arrTime: '09:35', arrCode: 'DXN', price: '₹7,139', offer_text: '10% OFF using SBIDC code | ₹ 255 OFF using GIRUSH code' },
    { airline: 'Akasa Air', logo: Indigo, depTime: '07:25', depCode: 'NMI', duration: '2h 10m', stops: 'Non-stop', arrTime: '09:35', arrCode: 'DXN', price: '₹7,139' },
    { airline: 'Akasa Air', logo: Indigo, depTime: '07:25', depCode: 'BOM', duration: '2h 10m', stops: 'Non-stop', arrTime: '09:35', arrCode: 'DEL', price: '₹7,139' },
    { airline: 'Akasa Air', logo: Indigo, depTime: '07:25', depCode: 'BOM', duration: '2h 10m', stops: 'Non-stop', arrTime: '09:35', arrCode: 'DEL', price: '₹7,139' },
    { airline: 'Akasa Air', logo: Indigo, depTime: '07:25', depCode: 'BOM', duration: '2h 10m', stops: 'Non-stop', arrTime: '09:35', arrCode: 'DEL', price: '₹7,139' },
    { airline: 'Akasa Air', logo: Indigo, depTime: '07:25', depCode: 'BOM', duration: '2h 10m', stops: 'Non-stop', arrTime: '09:35', arrCode: 'DEL', price: '₹7,139' },
    { airline: 'Akasa Air', logo: Indigo, depTime: '07:25', depCode: 'BOM', duration: '2h 10m', stops: 'Non-stop', arrTime: '09:35', arrCode: 'DEL', price: '₹7,139' },
    { airline: 'Akasa Air', logo: Indigo, depTime: '07:25', depCode: 'BOM', duration: '2h 10m', stops: 'Non-stop', arrTime: '09:35', arrCode: 'DEL', price: '₹7,139' },
]

const RETURN_FLIGHTS = ONWARD_FLIGHTS

const COMPACT_DATE_BREAKPOINTS = {
    0: { slidesPerView: 1.5 },
    576: { slidesPerView: 2.5 },
    768: { slidesPerView: 3 },
}

const FlightResultColumn = ({ route, count, dates, flights }) => {
    const [sortBy, setSortBy] = useState('smart')

    return (
        <div className='topTabFlightDate'>
            <FlightDateTabs dates={dates} initialActiveIndex={1} slidesPerView={3} breakpoints={COMPACT_DATE_BREAKPOINTS} />

            <div className='sortingCount'>
                <small className='resultCard__airlineName'>{route}</small>
                <small>{count} Flights Available</small>
            </div>

            <div className='filterTabs'>
                {SORT_TABS.map((tab) => (
                    <div
                        key={tab.key}
                        className={`filterTab ${sortBy === tab.key ? 'active' : ''}`}
                        onClick={() => setSortBy(tab.key)}
                    >
                        <div className='filterTab__label'>{tab.label}{tab.key === 'smart' && ' ▾'}</div>
                    </div>
                ))}
            </div>

            <div className='resultFlight'>
                <RoundFlightResults flights={flights} />
            </div>
        </div>
    )
}

const RoundFlightList = () => {
    return (
        <>
            <section className='allSearchArea commonTopPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <div className='innerSearch bgWhite paddingCommon20 borderRadius20'>
                                <div className='innerSearchBar'>
                                    <div className='innerSearchField'>
                                        <label>From</label>
                                        <input type="text" defaultValue="BBI - Bhubaneswar" />
                                    </div>
                                    <div className='innerSwapIcon'>
                                        <img src={FlightTrip} alt="Swap" />
                                    </div>
                                    <div className='innerSearchField'>
                                        <label>To</label>
                                        <input type="text" defaultValue="DEL - New Delhi" />
                                    </div>
                                    <div className='innerSearchField'>
                                        <label>Departure</label>
                                        <input type="text" defaultValue="Fri, 19 Jun" />
                                    </div>
                                    <div className='innerSearchField'>
                                        <label>Return</label>
                                        <input type="text" defaultValue="Sat, 27 Jun" />
                                    </div>
                                    <div className='innerSearchField'>
                                        <label>Travellers &amp; Class</label>
                                        <input type="text" defaultValue="1 Traveller,  Economy" />
                                    </div>
                                    <button type="button" className='innerSearchBtn'>
                                        Search
                                        <span>&#8250;</span>
                                    </button>
                                </div>

                                <div className='specialFares'>
                                    <span className='specialFaresLabel'>Special Fares <span className='optional'>(Optional)</span> :</span>
                                    <div className='specialFarePill'>Student</div>
                                    <div className='specialFarePill'>Senior Citizen</div>
                                    <div className='specialFarePill'>Armed Forces</div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='searchListing'>
                                <div className='filterBar'>
                                    <FilterSidebar />
                                </div>
                                <div className='searchResult'>
                                    <div className='roundSplit'>
                                        <div className='roundSplitCol'>
                                            <FlightResultColumn route="DEL - BOM" count={140} dates={ONWARD_DATES} flights={ONWARD_FLIGHTS} />
                                        </div>
                                        <div className='roundSplitCol'>
                                            <FlightResultColumn route="BOM - DEL" count={133} dates={RETURN_DATES} flights={RETURN_FLIGHTS} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </section>
        </>
    )
}

export default RoundFlightList
